import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import FormError from '../form/FormError';

import get from 'lodash/get';
import findLast from 'lodash/findLast';
import SelectedPlan from './SelectedPlan';
import PaymentMethodForm from './PaymentMethodForm';

// import { Link } from 'react-router-dom';
import Loading from '../helpers/Loading';

import { updateSubscriptionSuccess, loadProject, reloadProfile } from '../../actions';
import { Account } from '../../api';


import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import faCheck from '@fortawesome/fontawesome-pro-solid/faCheckCircle';


import { currentCustomerInfoSelector } from '../../reducers/selectors';

import plans from './plans';

import classNames from 'classnames';

const mapStateToProps = state => ({ currentProject: state.currentProject, customerInfo:  currentCustomerInfoSelector(state) });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ updateSubscriptionSuccess, loadProject, reloadProfile }, dispatch)
};


class CheckoutForm extends Component {
  
  constructor (props){
    super(props)
    
    this.onPaymentMethodSuccess = this.onPaymentMethodSuccess.bind(this);
    this.checkout = this.checkout.bind(this);
    this.onPlanChange = this.onPlanChange.bind(this);
    this.changeLoading = this.changeLoading.bind(this);
    
    
    const plan_id = get(this.props, 'match.params.plan_id');
    let plan = this.props.plan
    
    if ( plan_id ){
      const plan_split = plan_id.split('_')
      plan = {id: plan_split[0], annual: plan_split[1] !== 'monthly'}
    }
    
    this.state = {
      plan: plan,
      stripe_plan_id: this.stripePlanId(plan),
      token: null,
      loading: false,
      changeCard: false,
      subscribeError: false,
      success: false
    }
  }
  
  componentWillMount () {
    
  }
  
  componentWillReceiveProps (nextProps){
    if (nextProps.plan !== this.props.plan){
      this.onPlanChange(nextProps.plan);
    }
  } 
  
  onPaymentMethodSuccess (params){
    this.setState({token:params});
    setTimeout(this.checkout)
  }
  
  checkout (){
    const { stripe_plan_id, token } = this.state;
    const { updateSubscriptionSuccess, reloadProfile, loadProject, onSuccess } = this.props;
    const hasCard = !!token;
    
    if (!stripe_plan_id || !hasCard)
      return
    
    this.setState({loading: true});
    Account.updateSubscription({ plan_id: stripe_plan_id, source: token}).then( (data)=>{
      updateSubscriptionSuccess(data);
      reloadProfile();
      loadProject(null, {success_msg: true, noredirect: !!onSuccess});
      this.setState({loading: false, subscribeError: false, success: true});
      
      if (onSuccess)
        setTimeout(onSuccess, 2000)
    }, (res) => {
      this.setState({success: false, loading: false, subscribeError: res.response && res.response.data && res.response.data.error});
    });
  }
  
  stripePlanId (plan){
    const { id, annual } = plan;
    const planDetails = plans[id];
    
    return planDetails && `${planDetails.stripe_id || id}_${annual ? 'annual' : 'monthly'}`
  }
  
  onPlanChange (plan){
    this.setState({plan: plan, stripe_plan_id: this.stripePlanId(plan)});
  }
  
  changeLoading (loading) {
    this.setState({loading: loading});
  }
  
  render() {
    const { customerInfo } = this.props;
    const { success, loading, plan, subscribeError } = this.state;
    const defaultSource = customerInfo && customerInfo.default_source && findLast(get(customerInfo, 'sources') || [], {id: customerInfo.default_source}); 
    
    return ( plan ?
      <div className={classNames({"checkout-form": true, success})}>
        {success && <div className="success-curtain">
          <FA icon={faCheck} />
          <div>You&apos;re all set!</div>
        </div> }
        
        <div style={{opacity: success === true ? 0 : 1}}>
          {plan && <SelectedPlan plan={plan} onChange={this.onPlanChange} withAnnualSwitch={true} />}
          {subscribeError && <FormError children={subscribeError} />}
          {loading && <Loading curtain />}
          <PaymentMethodForm onSuccess={this.onPaymentMethodSuccess} changeLoading={this.changeLoading} defaultSource={defaultSource} />
        </div>
      </div>
    : null );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(CheckoutForm);


// WEBPACK FOOTER //
// ./src/components/billing/CheckoutForm.js